
import { NavTopMenu } from '../shared/NavTopMenu';
import { SidebarMenu } from '../shared/SidebarMenu';


import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { validateAccessUser } from '../../constants/component/validateAccessUser';
import * as view from '../../constants/models/viewsList';

import ReactPlayer from 'react-player';
import React from "react";
import ModalTerms from "../shared/ModalTerms";
import  videoCheque from "../../assets/videos/01-cheque.mp4"
import videoFicha from "../../assets/videos/02-ficha.mp4"
import videoPago from  "../../assets/videos/03-pago.mp4"
import videoTransferencia from  "../../assets/videos/04-transferencia.mp4"
import { Footer } from '../shared/Footer';
import AdvertisingModal from '../shared/AdvertisingModal';

// import { fetchImages } from '../../actions/images';
// import { fetchVideos } from '../../actions/videos';
// import Carousel from '../../constants/customComponent/Carousel';
// import { FFmpeg } from '@ffmpeg/ffmpeg';
// import { fetchVideos } from '../../actions/videos';

//Modal Pop-up

export const MainScreen = () => {
  const { user } = useSelector(state => state.auth);
  //modal

  //   console.log("User", user)
  //   const {images, isLoadingImages,reload:realoadImage} = useSelector(state=> state.images)
  //   // const {videos, isLoadingVideos,reload:reloadVideo} = useSelector(state=> state.videos)
  //    const dispatch = useDispatch()
  //   useEffect(() => {
  //     // Aquí se llama a fetchVideos desde las acciones de Redux
  //     if(( !images && !isLoadingImages ) || realoadImage){
  //       dispatch(fetchImages(true))
  //     }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [dispatch]);

  // useEffect(()=>{
  //   if((!videos && !isLoadingVideos) || reloadVideo){

  //     dispatch(fetchVideos(false));
  //   }

  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[dispatch])
  return (
    <>
      <div className="container-fluid p-0 m-0">
        <div className="row flex-nowrap p-0 m-0">
          <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
            <SidebarMenu />
          </div>
          <div className="col p-0 ms-1 me-1">
            <NavTopMenu />
            <div className="container ps-3 pe-3 container-size">
              <div className="row base-container ">
                <div className="col-12 border-title text-title pt-2 pb-2 ps-4">
                  <span className="h4">Bienvenido</span>
                </div>
                <div className="col-12 p-5 mt-4">
                  <span className="text-content">
                    Portal E2E de Cooperativa La Cruz Azul, S.C.L. dedicado al control de operaciones de clientes registrados.
                  </span>

                </div>
                <div className="col-12 ps-4 pe-4 pt-1 pb-5">
                  <div className='row w-100 d-flex justify-content-center'>
                    <div className={`col-md-4 ${validateAccessUser(view.VIEW_PREVIOUS_PROGRAM, user) ? 'd-inline' : 'd-none'}`}>
                      <Link to='/operation/previous-program' className="text-option">
                        <div className="w-100 border-content bg-content pt-2 pb-2 h-100">
                          <div className="row">
                            <div className="col-12 d-flex justify-content-center">
                              <i className="fas fa-boxes fa-2x"></i>
                            </div>
                            <div className="col-12 d-flex justify-content-center pt-2">
                              <span className="ms-1 text-title">Programa previo</span>
                            </div>
                            <div className="col-12 text-description pt-2">
                              <span className="ms-1">Consulte información sobre el calendario de pedidos.</span>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className={`col-md-4 mt-3 mt-md-0 ${validateAccessUser(view.VIEW_PAYMENT, user) ? 'd-inline' : 'd-none'}`}>
                      <Link to='/operation/payment' className="text-option">
                        <div className="w-100 border-content bg-content pt-2 pb-2 h-100">
                          <div className="row">
                            <div className="col-12 d-flex justify-content-center">
                              <i className="fas fa-credit-card fa-2x"></i>
                            </div>
                            <div className="col-12 d-flex justify-content-center pt-2">
                              <span className="ms-1 text-title">Pagos</span>
                            </div>
                            <div className="col-12 text-description pt-2">
                              <span className="ms-1">Consulte sus facturas y realice operaciones bancarias.</span>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className={`col-md-4 mt-3 mt-md-0 ${validateAccessUser(view.VIEW_SALE_ORDER, user) ? 'd-inline' : 'd-none'}`}>
                      <Link to='/operation/sale-order' className="text-option">
                        <div className="w-100 border-content bg-content pt-2 pb-2 h-100">
                          <div className="row">
                            <div className="col-12 d-flex justify-content-center">
                              <i className="fas fa-coins fa-2x"></i>
                            </div>
                            <div className="col-12 d-flex justify-content-center pt-2">
                              <span className="ms-1 text-title">Órdenes de venta</span>
                            </div>
                            <div className="col-12 text-description pt-2">
                              <span className="ms-1">De seguimiento a sus ordenes de venta.</span>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                  </div>
                </div>

                <div className="col-12 ps-4 pe-4 pt-1 pb-5">
                  <div className='row w-100 d-flex justify-content-center'>
                    <div className='col-md-6 d-flex justify-content-center'>
                      <div className="d-inline">
                        Cheque en línea
                        <ReactPlayer
                          url={videoCheque}
                          playing={true}
                          light={true}
                          controls={true}
                          width={400}
                          height={225}
                        />
                      </div>
                    </div>
                    <div className='col-md-6 mt-3 mt-md-0 d-flex justify-content-center'>
                      <div className="d-inline">
                        Generar ficha para transferencias
                        <ReactPlayer
                          url={videoFicha}
                          playing={false}
                          light={true}
                          controls={true}
                          width={400}
                          height={225}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 ps-4 pe-4 pt-1 pb-5">
                  <div className='row w-100 d-flex justify-content-center'>
                    <div className='col-md-6 mt-3 mt-md-0 d-flex justify-content-center'>
                      <div className="d-inline">
                        Pago de servicio BBVA
                        <ReactPlayer
                          url={videoPago}
                          playing={false}
                          light={true}
                          controls={true}
                          width={400}
                          height={225}
                        />
                      </div>
                    </div>
                    <div className='col-md-6 mt-3 mt-md-0 d-flex justify-content-center'>
                      <div className="d-inline">
                        Transferencia interbancaria
                        <ReactPlayer
                          url={videoTransferencia}
                          playing={false}
                          light={true}
                          controls={true}
                          width={400}
                          height={225}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-12 d-flex flex-column align-items-center justify-content-center ps-4 pe-4 pt-1 pb-5">
                        <Carousel />
                      </div> */}

           
                <ModalTerms an8={user.noCustomer}/>
                <AdvertisingModal/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}
